export default "__VITE_ASSET__ppLUBTeY__"